export const NO_BLOGS_MESSAGE_TITLE = 'No Blogs Found.';
export const NO_BLOGS_MESSAGE_DESC =
  'After the blogs are published, new blogs will be displayed here.';
export const BLOGS_DETAILS_ERROR_TITLE = 'Error Fetching ...';
export const BLOGS_DETAILS_ERROR_MESSAGE =
  'We are unable to fetch the details due to a temporary glitch. Please try after sometime. Apologize for inconvenience';
